import React from 'react';
import { Panel, Tab, Row, Col, Nav, NavItem } from 'react-bootstrap';
import Store from 'stores/TariffsStore';
import { extend, each } from 'lodash';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import PropertiesEditor from './TariffPropsEditor';
import PricesTable from './TariffPricesTable';
import OtherPropertiesEditor from './TariffOtherPropsEditor';
import TariffShippersTable from './TariffShippersTable';
const kDefaultSlug = 'truckload_tariff';
const kDefaultType = 'tabular';
const kBoxToPalletConversionRate = 67;
const kDefaultMarkets = ['LAX'];
const isFloatZero = (a) => {
    return (a === null || a === void 0 ? void 0 : a.toFixed(2)) === '0.00';
};
class TariffEditor extends React.Component {
    constructor() {
        super(...arguments);
        this.tariff = null;
        this.propertiesValid = true;
        this.priceMatrixValid = true;
        this.onChange = () => {
            if (Store.getStatus() === 'success') {
                const propsTariff = this.props.tariff;
                const storeTariff = Store.getTariff();
                if (storeTariff._id) {
                    this.tariff = extend({}, storeTariff);
                }
                else {
                    this.tariff = extend({}, propsTariff);
                }
                this.propertiesValid = true;
                this.priceMatrixValid = true;
                this.notifyUpdate(false);
            }
            else {
                this.notifyUpdate(true);
            }
        };
        this.handlePropertiesChange = () => {
            return (key, value) => {
                this.tariff[key] = value;
                this.propertiesValid = this.tariff.name && this.tariff.name.length > 0;
                this.notifyUpdate(true);
            };
        };
        this.handlePricesDataChange = () => {
            return (pricesData) => {
                const pricesValid = this.validatePrices(pricesData);
                const zonesValid = this.validateZones(pricesData);
                Object.keys(pricesData).forEach((property) => {
                    if (property) {
                        this.tariff[property] = pricesData[property];
                    }
                });
                this.priceMatrixValid = zonesValid && pricesValid;
                this.notifyUpdate(true);
            };
        };
        this.validateZones = (pricesData) => {
            let valid = true;
            if (pricesData.zones) {
                for (let index = 0; index < pricesData.zones.length; ++index) {
                    const zone = pricesData.zones[index];
                    if (index) {
                        valid = zone[0] > 0 && zone[1] >= zone[0];
                    }
                    else {
                        valid = zone[1] > 0;
                    }
                    if (!valid) {
                        break;
                    }
                }
            }
            return valid;
        };
        this.validatePrices = (pricesData) => {
            let valid = true;
            if (pricesData.zone_to_load) {
                for (let index = 0; index < pricesData.zone_to_load.length; ++index) {
                    const row = pricesData.zone_to_load[index];
                    for (let rowIndex = 0; rowIndex < row.length; ++rowIndex) {
                        const price = row[rowIndex];
                        if (isFloatZero(price)) {
                            valid = false;
                            break;
                        }
                    }
                }
            }
            return valid;
        };
        this.notifyUpdate = (edited) => {
            if (this.props.onChange) {
                const validated = this.propertiesValid && this.priceMatrixValid;
                this.props.onChange(this.tariff, edited, validated);
            }
        };
        this.newTariff = () => {
            return {
                name: '',
                slug: kDefaultSlug,
                type: kDefaultType,
                markets: kDefaultMarkets,
                zones: [],
                weight_ranges: [],
                load_ranges: [],
                zone_to_weight: [],
                zone_to_load: [],
                minimum_distance: 0,
                minimum_weight: 0,
                minimum_cost: 0,
                maximum_cost: 0,
                cost_per_extra_mile: 0,
                cost_per_extra_lb: 0,
                is_default: false,
                box_to_pallet_conversion_rate: kBoxToPalletConversionRate,
            };
        };
    }
    componentDidMount() {
        Store.addChangeListener(this.onChange);
    }
    componentWillUnmount() {
        Store.removeChangeListener(this.onChange);
    }
    render() {
        const { t } = this.props;
        if (!this.tariff) {
            this.tariff = this.props.tariff || this.newTariff();
        }
        const disableShippers = !(this.tariff && this.tariff._id);
        return (React.createElement("div", null,
            React.createElement(Tab.Container, { id: "left-tabs-example", defaultActiveKey: "1" },
                React.createElement(Row, { className: "clearfix" },
                    React.createElement(Col, { sm: 2 },
                        React.createElement(Nav, { bsStyle: "pills", stacked: true },
                            React.createElement(NavItem, { eventKey: "1" }, t('PROPERTIES')),
                            React.createElement(NavItem, { eventKey: "2", disabled: disableShippers }, titleize(t('SHIPPER', { count: 2 }))),
                            React.createElement(NavItem, { eventKey: "3" }, titleize(t('PRICE', { count: 2 }))),
                            React.createElement(NavItem, { eventKey: "4" }, t('OTHER')))),
                    React.createElement(Col, { sm: 10 },
                        React.createElement(Tab.Content, { animation: true },
                            React.createElement(Tab.Pane, { eventKey: "1" },
                                React.createElement(Panel, null,
                                    React.createElement(PropertiesEditor, { tariff: this.tariff, tariffsList: this.props.tariffsList, onChange: this.handlePropertiesChange(), fill: true }))),
                            React.createElement(Tab.Pane, { eventKey: "2" },
                                React.createElement(Panel, { className: "table-responsive" },
                                    React.createElement(TariffShippersTable, { tariff: this.tariff }))),
                            React.createElement(Tab.Pane, { eventKey: "3" },
                                React.createElement(Panel, { className: "table-responsive" },
                                    React.createElement(PricesTable, { tariff: this.tariff, onChange: this.handlePricesDataChange() }))),
                            React.createElement(Tab.Pane, { eventKey: "4" },
                                React.createElement(Panel, null,
                                    React.createElement(OtherPropertiesEditor, { tariff: this.tariff, onChange: this.handlePropertiesChange() })))))))));
    }
}
export default withTranslation()(TariffEditor);
